export default "__VITE_ASSET__BC6e0Nw7__"